import { MathUtils } from '@3d-scene/common/util/math-utils';

export type UnitName = '3d' | 'mm' | 'cm' | 'm' | 'inch' | 'ft';

export class UnitConverter {

  // 1m in each unit
  private static baseFactors: Record<UnitName, number> = {
    '3d': 10000,
    'mm': 1000,
    'cm': 100,
    'm': 1,
    'inch': 39.3701,
    'ft': 3.28084,
  };

  public static fromTo(sourceUnit: UnitName, targetUnit: UnitName, value: number): number {
    return value * this.baseFactors[targetUnit] / this.baseFactors[sourceUnit];
  }

  /** pass -1 for fractionDigits to skip rounding  */
  public static fromToRounded(sourceUnit: UnitName, targetUnit: UnitName, value: number, fractionDigits = 2): number {
    const result = value * this.baseFactors[targetUnit] / this.baseFactors[sourceUnit];
    return fractionDigits < 0 ? result : MathUtils.roundNumberValue(result, fractionDigits);
  }
}
